// Initialize product sliders
var productsSliders = document.getElementsByClassName('products-slider');
var productsSlidersOptions = {
  type: 'loop',
  pagination: true,
  perPage: 3,
  breakpoints: {
    990: {
      perPage: 2,
    },
    750: {
      perPage: 1,
    },
  }
};

function gmCustomSliderWarning(component) {
  if (window.console && typeof window.console.warn === 'function') {
    window.console.warn('[GemsMantra] Optional slider initialization failed: ' + component);
  }
}

if (typeof window.Splide === 'function') {
  for (var productsSlidersCount = 0; productsSlidersCount < productsSliders.length; productsSlidersCount++) {
    try {
      new window.Splide(productsSliders[productsSlidersCount], productsSlidersOptions).mount();
    } catch (error) {
      gmCustomSliderWarning('products-slider');
    }
  }
}

function gmCustomReady(callback) {
  if (typeof window.jQuery !== 'function') return;
  window.jQuery(document).ready(function () {
    callback(window.jQuery);
  });
}

function gmCustomSwiper(selector, options) {
  if (typeof window.Swiper !== 'function' || !document.querySelector(selector)) return null;
  try {
    return new window.Swiper(selector, options);
  } catch (error) {
    gmCustomSliderWarning(selector);
    return null;
  }
}

gmCustomReady(function ($) {
  $('.product-categories_list a[data-toggle="tab"]').on('click', function (e) {
    e.preventDefault();
    const id = $(this).attr('href');

    $('.product-categories_list a').removeClass('active');
    $('.tab-content > div').hide();

    $(this).addClass('active');
    $(id).show();
  });
});

var swiper = gmCustomSwiper('.featured_slide', {
  slidesPerView: 1,
  centeredSlides: true,
  spaceBetween: 10,
  slidesPerView: 1.3,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.featured_slide-next',
    prevEl: '.featured_slide-prev'
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 13.42,
      centeredSlides: false,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 27,
      centeredSlides: false,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 10,
      centeredSlides: false,
    },
  },
});

var collSlider = gmCustomSwiper('.col_slider', {
  slidesPerView: 1.5,
  centeredSlides: true,
  spaceBetween: 10,
  slidesPerView: 1.3,
  loop: false,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.col_slider-next',
    prevEl: '.col_slider-prev'
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 13.42,
      centeredSlides: false,
      loop: true,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 27,
      centeredSlides: false,
      loop: true,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 10,
      centeredSlides: false,
      loop: true,
    },
  },
});

var featuredSlider = gmCustomSwiper('.collection_slider', {
  slidesPerView: 1,
  centeredSlides: false,
  loop: false,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.collection_slider-next',
    prevEl: '.collection_slider-prev'
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      centeredSlides: false,
      loop: true,
    },
    1150: {
      slidesPerView: 3,
      centeredSlides: false,
      loop: true,
    },
    1400: {
      slidesPerView: 4, // Fixed the issue here, it should be just '3' not '3s'
      centeredSlides: false,
      loop: true,
    },
  },
});

var blogSlider = gmCustomSwiper('.blog_slider', {
  slidesPerView: 1.2,
  centeredSlides: true,
  spaceBetween: 10,
  loop: false,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.blog_slider-next',
    prevEl: '.blog_slider-prev'
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 13.42,
      centeredSlides: false,
      loop: true,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 27,
      centeredSlides: false,
      loop: true,
    },
    1024: {
      slidesPerView: 3, // Fixed the issue here, it should be just '3' not '3s'
      spaceBetween: 10,
      centeredSlides: false,
      loop: true,
    },
  },
});

var proSlider = gmCustomSwiper('.pro_review-slider', {
  slidesPerView: 1.6,
  centeredSlides: false,
  spaceBetween: 10,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.pro_review_next',
    prevEl: '.pro_review_prev'
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 13.42,
      centeredSlides: false,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 27,
      centeredSlides: false,
    },
    1600: {
      slidesPerView: 4, // Fixed the issue here, it should be just '3' not '3s'
      spaceBetween: 10,
      centeredSlides: false,
    },
  },
});

function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName('tabcontent');
  tablinks = document.getElementsByClassName('tablinks');

  var activeTab = evt.currentTarget;

  if (activeTab.classList.contains('active')) {
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = 'none';
    }
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].classList.remove('active');
    }
  } else {
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = 'none';
    }
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].classList.remove('active');
    }

    document.getElementById(cityName).style.display = 'block';
    activeTab.classList.add('active');
  }
}

// Automatically open the first tab when the page loads
/* window.onload = function() {
  // Trigger a click on the first tab to open it by default
  var firstTab = document.getElementsByClassName("tablinks")[0];
  var firstTabContent = document.getElementsByClassName("tabcontent")[0];
  if (firstTab) {
    firstTab.classList.add("active");
    firstTabContent.style.display = "block";
  }
} */

gmCustomReady(function ($) {
  $(document).on('click', '.read_more_less', function (e) {
    e.preventDefault();
    if ($('.product-description-full:visible').length) {
      $('.product-description-full').fadeOut(function () {
        $('.product-description-short').fadeIn();
      });
    } else {
      $('.product-description-short').fadeOut(function () {
        $('.product-description-full').fadeIn();
      });
    }
  });

  /* $(document).on('click', '#sticky-buy-now-btn', function () {
    if($('magic-checkout-btn').length) {
      $('magic-checkout-btn').click();
    }
    $('shopify-buy-it-now-button button').click();
  }); */
});

(function () {
  const mobileSectionId = 'shopify-section-template--19743224234237__mobile_collection_list_VbPVVR';
  const slideshowSectionId = 'shopify-section-template--19743224234237__slideshow_Hn6YwU';

  function reorderSections() {
    const mobileSection = document.getElementById(mobileSectionId);
    const slideshowSection = document.getElementById(slideshowSectionId);

    if (!mobileSection || !slideshowSection || !slideshowSection.parentNode) return;

    const parent = slideshowSection.parentNode;
    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      if (mobileSection.nextSibling !== slideshowSection) {
        parent.insertBefore(mobileSection, slideshowSection);
      }
    } else {
      if (slideshowSection.nextSibling !== mobileSection) {
        parent.insertBefore(mobileSection, slideshowSection.nextSibling);
      }
    }

    const targetElement = mobileSection.querySelector('.mobile-collection-items');
    if (targetElement) {
      targetElement.classList.add('active');
    }
  }

  document.addEventListener('DOMContentLoaded', reorderSections);
  window.addEventListener('resize', reorderSections);
})();

gmCustomReady(function ($) {
  $('.custom-mega-menu').each(function () {
    var $menu = $(this);
    var $tabs = $menu.find('.custom-mega-sidebar li');
    var $panels = $menu.find('.custom-mega-panel');

    $tabs.on('mouseenter', function () {
      var target = $(this).data('panel');

      $tabs.removeClass('active');
      $(this).addClass('active');

      $panels.hide();
      $menu.find('.custom-mega-panel[data-panel-id="' + target + '"]').show();
    });
  });
});

gmCustomReady(function ($) {
  var $timer = $('#gmTimer');
  if (!$timer.length) return;

  var $container = $timer.closest('.gm-offer-bar');
  var hours = parseInt($container.data('hours'), 10) || 1;
  var duration = hours * 60 * 60;

  /* Unique per product */
  var productId = $('body').data('product-id') || '{{ product.id }}';
  var storageKey = 'gm_offer_end_' + productId;

  function getNow() {
    return Math.floor(Date.now() / 1000);
  }

  function createNewCycle() {
    var newEnd = getNow() + duration;
    localStorage.setItem(storageKey, newEnd);
    return newEnd;
  }

  var endTime = parseInt(localStorage.getItem(storageKey), 10) || createNewCycle();

  function updateTimer() {
    var now = getNow();
    var remaining = endTime - now;

    /* 🔁 Restart cycle automatically */
    if (remaining <= 0) {
      endTime = createNewCycle();
      remaining = endTime - now;
    }

    var h = String(Math.floor(remaining / 3600)).padStart(2, '0');
    var m = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
    var s = String(remaining % 60).padStart(2, '0');

    $timer.text(h + ':' + m + ':' + s);
  }

  updateTimer();
  setInterval(updateTimer, 1000);
});
